module.exports = __webpack_public_path__ + "img/ico-map.5af3cbe.svg";